import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import InputBox from "../../Generic/InputBox";
import Checkbox from "../../Generic/Checkbox";
import { errorNotification, successNotification } from "../../Generic/Notifications";
import StudioService from "../Services/StudioService";
import Dropdown from "../../Generic/Dropdown";
import Textarea from "../../Generic/Textarea";
import Button from "../../Generic/Button";
import SuccessButton from "../../Generic/SuccessButton";
import CookBookConnector from "../Connector/CookBookConnector";
import { useNavigate } from "react-router-dom";
import { DispenseType, dispenseTypes, DispensePatternType, dispensePatternTypes } from "../Reducer";
import DecimalInput from "../../Generic/NumberInput";

const Page = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0 1.5rem 1rem 1.5rem;
	overflow: hidden;
`;

const Div = styled.div`
	color: ${(props) => props.color};
	background: ${(props) => props.background};
	position: ${(props) => props.position};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	top: ${(props) => props.top};
	z-index: ${(props) => props.zIndex};
	max-height: ${(props) => props.maxHeight};
	gap: ${(props) => props.gap};
	overflow-y: ${(props) => props.overflowY};
	border: ${(props) => props.border};
	cursor: ${(props) => props.cursor};
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
	${(props) =>
		props.active &&
		css`
			background: rgba(45, 35, 66, 0.8);
			color: #fff;
		`}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
`;

const Header = styled.div`
	display: flex;
	justify-content: flex-start;
	font-size: 2.3rem;
	margin: ${(props) => props.margin};
	width: 100%;
`;

// Reusable layout components
const Toolbar = styled(Div)`
	padding: 1rem 0;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;

const Content = styled(Div)`
	flex-direction: column;
	overflow-y: auto;
	max-height: 80%;
	gap: 1.5rem;
	width: 100%;
`;

const RowWrap = styled(Div)`
	flex-wrap: wrap;
	gap: 1rem;
`;

const RowAlignCenter = styled(Div)`
	padding: 0.5rem 0;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	height: 100%;
`;

const RowEndGap = styled(Div)`
	width: 100%;
	align-items: flex-end;
	gap: 1rem;
`;

const Column = styled(Div)`
	flex-direction: column;
`;

const FieldColumn = styled(Column)`
	/* Column container for a label + input */
`;

const SectionHeader = styled(Div)`
	width: 100%;
	font-size: 1.4rem;
	font-weight: 600;
	margin-top: 1rem;
`;

const Label = styled(Span)`
	color: rgba(0, 0, 0, 0.6);
`;

const AllergenChip = styled(Div)`
	cursor: pointer;
	font-size: 14px;
	padding: 0.5rem;
	border: 1px solid rgba(0, 0, 0, 0.4);
`;

const ActionRow = styled(Div)`
	justify-content: flex-end;
	gap: 1rem;
	padding: 1rem 0;
`;

const DefaultInput = (props) => {
	const { width, breakpoint, widthBeforeBreakpoint, ...rest } = props;
	return <InputBox padding="0.5rem" margin="0.5rem 0 0 0" width={"20rem"} {...rest} />;
};

const DefaultDecimalInput = (props) => {
	const { width, breakpoint, widthBeforeBreakpoint, ...rest } = props;
	return <DecimalInput padding="0.5rem" margin="0.5rem 0 0 0" width={"20rem"} {...rest} />;
};

const DefaultDropdown = (props) => {
	return (
		<Dropdown
			padding="0.5rem"
			headerFontSize="1rem"
			boxShadow=""
			border="1px solid rgba(0,0,0,0.6)"
			margin="0.5rem 0 0 0"
			{...props}
		/>
	);
};

const IngredientCreate = (props) => {
	const { objectToEdit, HeatingProfiles, DispenserTypes, Allergens, containerTypes, baseTypes, spoutTypes, changeEditMode } = props;
	const navigate = useNavigate();

	const [baseItem, isBaseItem] = useState(false);
	const [agitationRequired, setAgtitationRequired] = useState(false);
	const [dispenserType, setDispenserType] = useState(null);
	const [heatingProfile, setHeatingProfile] = useState("NO_HEATING");
	const [dispenseType, setDispenseType] = useState(null);
	const [dispensePatternType, setDispensePatternType] = useState(null);
	const [selectedAllergens, setSelectedAllergens] = useState([]);

	useEffect(() => {
		return () => {
			changeEditMode({ objectToEdit: {} });
		};
	}, [changeEditMode]);

	function updateData(evnt) {
		//Get numeric input for fields if type is set as number
		const payload =
			evnt.target.type === "number"
				? { column: evnt.target.id, value: evnt.target.valueAsNumber }
				: { column: evnt.target.id, value: evnt.target.value };
		props.updateIngredient(payload);
	}

	async function sendUpdatedData() {
		let payload = props.objectToEdit;

		payload = {
			...payload,
			inventoryData: {
				...payload.inventoryData,
				dispenseDetails: {
					...payload.inventoryData?.dispenseDetails,
					agitationRequired: baseItem ? false : agitationRequired,
					dispenserType: dispenserType,
					dispenseType: dispenseType,
					dispensePatternType: dispensePatternType,
					//Confirm and remove this later on.
					accuracyFactor: 1,
					rpmConstraints: payload?.inventoryData.dispenseDetails?.rpmConstraints
						? Object.values(payload.inventoryData.dispenseDetails.rpmConstraints)
						: [],
				},
			},
			isBaseItem: baseItem,
			defaultHeatingProfile: heatingProfile,
			dietaryDetails: {
				...payload?.dietaryDetails,
				allergens: selectedAllergens,
			},

			//Hardcoded things which need to be taken as an input later on.
			baseIngredients: [],
			ingredientType: "basic",
			brandId: "kocafe",
			verified: false,
			colors: [],
			physicalProperties: {
				physicalType: "chunks",
				length: {
					min: 1,
					max: 2,
				},
				width: {
					min: 1,
					max: 2,
				},
				height: {
					min: 1,
					max: 2,
				},
			},
		};

		const response = await StudioService.createIngredient(payload);
		const { data, error } = response;
		if (data) {
			successNotification("Ingredient Created successfully");
			navigate(`/studio/ingredient/${data._id}`);
		}
		if (error) {
			errorNotification(error);
		}
	}

	function customUpdateEvent(key, value) {
		props.updateIngredient({ column: key, value });
	}

	function toggleAllergen(allergen) {
		if (selectedAllergens.includes(allergen)) {
			setSelectedAllergens((prev) => prev.filter((selectedAllergen) => selectedAllergen !== allergen));
		} else {
			setSelectedAllergens((prev) => {
				return [...prev, allergen];
			});
		}
	}

	// Render helpers
	function renderBasicInfo() {
		return (
			<>
				<RowEndGap>
					<Column>
						<Label>Name</Label>
						<Div jContent="" width="100%">
							<DefaultInput id={"name"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.name} />
						</Div>
					</Column>
					<Div height="100%" margin="0 0 0.5rem 0">
						<Checkbox value={baseItem} onClick={(e) => isBaseItem(e.target.checked)} />
						<Span margin="0 0 0 0.5rem">Base Item</Span>
					</Div>
				</RowEndGap>
				<Div width="100%" alignItem="center">
					<Column width="100%">
						<Label>Description</Label>
						<Textarea margin="0.5rem 0 0 0" id={"description"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.description} padding="0.5rem" width="100%" />
					</Column>
				</Div>
				<Div width="100%" alignItem="center">
					<Column width="100%">
						<Label>Image Url</Label>
						<DefaultInput id={"imageUrl"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.imageUrl} />
					</Column>
				</Div>
				<Div width="100%" alignItem="center" gap="1rem">
					<Column width="20rem">
						<Label>Heating Profile</Label>
						<DefaultDropdown optionsList={HeatingProfiles} onChange={(val) => setHeatingProfile(val)} value={heatingProfile} />
					</Column>
				</Div>
			</>
		);
	}

	function renderDietaryDetails() {
		return (
			<>
				<SectionHeader>Dietary Details</SectionHeader>
				<Div flexDirection="column" width="100%" alignItem="" gap="1.5rem">
					<FieldColumn>
						<Label>Calories Per Gram</Label>
						<DefaultInput type="number" id={"dietaryDetails.caloriesPerGram"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.dietaryDetails?.caloriesPerGram} />
					</FieldColumn>
					<FieldColumn>
						<Label>Protein Per Gram</Label>
						<DefaultDecimalInput min={0} id={"dietaryDetails.proteinPerGram"} onChange={(e) => customUpdateEvent("dietaryDetails.proteinPerGram", e)} defaultValue={objectToEdit?.dietaryDetails?.proteinPerGram} />
					</FieldColumn>
					<FieldColumn>
						<Label>Fibre Per Gram</Label>
						<DefaultDecimalInput min={0} id={"dietaryDetails.fibrePerGram"} onChange={(e) => customUpdateEvent("dietaryDetails.fibrePerGram", e)} defaultValue={objectToEdit?.dietaryDetails?.fibrePerGram} />
					</FieldColumn>
					<FieldColumn>
						<Label>Allergens</Label>
						<RowWrap margin="0.5rem 0 0 0">
							{Allergens && selectedAllergens
								? Object.entries(Allergens).map(([allergenKey, allergenValue]) => {
									const isSelected = selectedAllergens.includes(allergenKey);
									return (
										<AllergenChip key={allergenKey} active={isSelected} onClick={() => toggleAllergen(allergenKey)}>
											{allergenValue}
										</AllergenChip>
									);
								})
								: ""}
						</RowWrap>
					</FieldColumn>
				</Div>
			</>
		);
	}

	function renderExpiryTime() {
		return (
			<>
				<SectionHeader>Expiry Time</SectionHeader>
				<RowWrap>
					<FieldColumn>
						<Label>Room</Label>
						<DefaultInput type="number" id={"expiresInMinutes.room"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.expiresInMinutes?.room} />
					</FieldColumn>
					<FieldColumn>
						<Label>Refrigerated</Label>
						<DefaultInput type="number" id={"expiresInMinutes.refrigerated"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.expiresInMinutes?.refrigerated} />
					</FieldColumn>
				</RowWrap>
			</>
		);
	}

	function renderFillDetails() {
		return (
			<>
				<SectionHeader>Fill Details</SectionHeader>
				<RowWrap width="100%" alignItem="center">
					<FieldColumn>
						<Label>Fill</Label>
						<DefaultInput type="number" id={"inventoryData.fillDetails.fillAmount"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.fillDetails?.fillAmount} />

						
					</FieldColumn>
					<FieldColumn>
						<Label>Max Fill</Label>
						<DefaultInput type="number" id={"inventoryData.fillDetails.maxAmount"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.fillDetails?.maxAmount} />
					</FieldColumn>
					<FieldColumn>
						<Label>Wastage</Label>
						<DefaultInput type="number" id={"inventoryData.fillDetails.wasteAmount"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.fillDetails?.wasteAmount} />
					</FieldColumn>
					<FieldColumn>
						<Label>Inventory Threshold Percentage</Label>
						<DefaultDecimalInput min={0} max={1} defaultValue={objectToEdit?.inventoryData?.fillDetails?.inventoryThresholdPercentage} onChange={(value) => customUpdateEvent("inventoryData.fillDetails.inventoryThresholdPercentage", value)} />
					</FieldColumn>
				</RowWrap>
			</>
		);
	}

	function renderDispenseDetails() {
		return (
			<>
				<SectionHeader>Dispensing Type</SectionHeader>
				<RowWrap>
					<Column width="20rem">
						<Label>Dispense Type</Label>
						<DefaultDropdown optionsList={dispenseTypes} onChange={(val) => setDispenseType(val)} value={dispenseType} />
					</Column>
					<Column width="20rem">
						<Label>Dispense Pattern Type</Label>
						<DefaultDropdown optionsList={dispensePatternTypes} onChange={(val) => setDispensePatternType(val)} value={dispensePatternType} />
					</Column>
				</RowWrap>
				{dispenseType === DispenseType.EQUATION_BASED_DISPENSING && dispensePatternType === DispensePatternType.NO_PATTERN ? (
					<>
						<SectionHeader>Equation Parameters</SectionHeader>
						<RowWrap>
							<FieldColumn>
								<Label>Constant</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.constant"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.constant} />
							</FieldColumn>
							<FieldColumn>
								<Label>Dispensing Rate</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.dispensingRate"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingRate} />
							</FieldColumn>
						</RowWrap>
					</>
				) : "" } 
				{dispenseType === DispenseType.DISPENSE_WITH_FEEDBACK && dispensePatternType === DispensePatternType.TO_AND_FRO? (
					<>
						<SectionHeader>To and Fro Dispense Parameters</SectionHeader>
						<RowWrap>
							<FieldColumn>
								<Label>Forward Dispense Degrees</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.dispensingCycleForwardDegrees"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardDegrees} />
							</FieldColumn>
							<FieldColumn>
								<Label>Forward Dispense RPM</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.dispensingCycleForwardRpm"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardRpm} />
							</FieldColumn>
							<FieldColumn>
								<Label>Backward Dispense Degrees</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.dispensingCycleBackwardDegrees"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardDegrees} />
							</FieldColumn>
							<FieldColumn>
								<Label>Backward Dispense RPM</Label>
								<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.dispensingCycleBackwardRpm"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardRpm} />
							</FieldColumn>
						</RowWrap>
					</>
				) : ""}
				<SectionHeader>Back Rotation Parameters</SectionHeader>
				<RowWrap>
					<FieldColumn>
						<Label>Back Rotation</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.backRotation"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotation} />
					</FieldColumn>
					<FieldColumn>
						<Label>Back Rotation RPM</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.dispenseConfig.backRotationRPM"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotationRPM} />
					</FieldColumn>
				</RowWrap>
				<SectionHeader>Dispensing Parameters</SectionHeader>
				<RowWrap>
					<FieldColumn>
						<Label>Prime Rotation Count</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.primeRotationCount"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.primeRotationCount} />
					</FieldColumn>
					<FieldColumn>
						<Label>Accuracy Buffer</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.accuracyBuffer"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.accuracyBuffer} />
					</FieldColumn>
					<RowAlignCenter>
						<Checkbox disabled={dispenseType === DispenseType.DISPENSE_WITH_FEEDBACK} value={agitationRequired} onClick={(e) => setAgtitationRequired(e.target.checked)} />
						<Span margin="0 0 0 0.5rem">Agitation Required</Span>
					</RowAlignCenter>
				</RowWrap>
			</>
		);
	}

	function renderRpmConstraints() {
		return (
			<>
				<SectionHeader>RPM Constraints</SectionHeader>
				<RowWrap>
					<FieldColumn>
						<Label>Min RPM</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.rpmConstraints.0"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.rpmConstraints?.[0]} />
					</FieldColumn>
					<FieldColumn>
						<Label>Max RPM</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.rpmConstraints.1"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.rpmConstraints?.[1]} />
					</FieldColumn>
				</RowWrap>
			</>
		);
	}

	function renderLandingTime() {
		return (
			<>
				<SectionHeader>Landing Time</SectionHeader>
				<RowWrap>
					<FieldColumn>
						<Label>Floor 0</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.landingTime.floor0"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.landingTime?.floor0} />
					</FieldColumn>
					<FieldColumn>
						<Label>Floor 1</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.landingTime.floor1"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.landingTime?.floor1} />
					</FieldColumn>
					<FieldColumn>
						<Label>Floor 2</Label>
						<DefaultInput type="number" id={"inventoryData.dispenseDetails.landingTime.floor2"} onChange={(e) => updateData(e)} defaultValue={objectToEdit?.inventoryData?.dispenseDetails?.landingTime?.floor2} />
					</FieldColumn>
				</RowWrap>
			</>
		);
	}

	function renderDispenserConfig() {
		return (
			<>
				<SectionHeader>Hardware Config</SectionHeader>
				<RowWrap>
					<Column width="20rem">
						<Label>Dispenser Type</Label>
						<DefaultDropdown optionsList={DispenserTypes} onChange={(val) => setDispenserType(val)} value={dispenserType} />
					</Column>
					<Column width="20rem">
						<Label>Canister</Label>
						<DefaultDropdown optionsList={containerTypes} onChange={(val) => customUpdateEvent("inventoryData.dispenseDetails.dispenserConfig.containerType", val)} value={objectToEdit?.inventoryData?.dispenseDetails?.dispenserConfig?.containerType} />
					</Column>
					<Column width="20rem">
						<Label>Base Block</Label>
						<DefaultDropdown optionsList={baseTypes} onChange={(val) => customUpdateEvent("inventoryData.dispenseDetails.dispenserConfig.baseType", val)} value={objectToEdit?.inventoryData?.dispenseDetails?.dispenserConfig?.baseType} />
					</Column>
					<Column width="20rem">
						<Label>Drain Tray</Label>
						<DefaultDropdown optionsList={spoutTypes} onChange={(val) => customUpdateEvent("inventoryData.dispenseDetails.dispenserConfig.spoutType", val)} value={objectToEdit?.inventoryData?.dispenseDetails?.dispenserConfig?.spoutType} />
					</Column>
				</RowWrap>
			</>
		);
	}

	return (
		<Page>
			<Toolbar>
				<Header>Create Ingredient</Header>
			</Toolbar>
			<Content>
				{renderBasicInfo()}
				{renderDietaryDetails()}
				{renderExpiryTime()}
				{renderFillDetails()}
				{renderDispenseDetails()}
				{renderRpmConstraints()}
				{renderLandingTime()}
				{renderDispenserConfig()}
				<ActionRow>
					<Div>
						<Button onClick={() => {}}>Back</Button>
					</Div>
					<Div>
						<SuccessButton onClick={() => { sendUpdatedData(); }}>
							Confirm
						</SuccessButton>
					</Div>
				</ActionRow>
			</Content>
		</Page>
	);
};

export default CookBookConnector(IngredientCreate);
